import queryString from "query-string";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { Grid, Chip, Typography } from "@mui/material";

import pages from "../../constants/pages";
import { useAxios, useComponent } from "../../hooks";
import { Loader, PageHeader } from "../../components";
import List from "./connection list components/List";
import {
  createCampaignObject,
  objectFromResponse,
} from "./connection list components/campaignObject";
import { toInternationalFormat } from "../../utils";
import { Accept, CancelButton } from "../css components/Button";
import LaunchCampaignConfirm from "./connection list components/dialog components/LaunchCampaignConfirm";

export default function Connection() {
  const axios = useAxios();
  const navigate = useNavigate();

  const { loader } = useComponent();

  const [connections, setConnections] = useState([]);
  const [sentChanges, setSentChanges] = useState({
    requestSent: "",
    verifiedProof: "",
  });
  const [users, setUsers] = useState({
    common: "",
    total: "",
    neededMandate: "",
    nonNeededMandate: "",
  });
  const [confirm, setConfirm] = useState({
    state: false,
  });
  const [formData, setFormData] = useState(createCampaignObject);
  const [launchCampaign, setLaunchCampaign] = useState(true);
  const { activeBrand, userID } = useSelector((state) => state.memberDetails);

  const campaignID = queryString.parse(window.location.search).campaignID;

  const [connectNowLoading, setConnectNowLoading] = useState([]);
  //
  useEffect(() => {
    loader.start(3);

    axios({
      url:
        "/user/brand/getCampaign?brandId=" +
        parseInt(activeBrand.ID) +
        "&campaignId=" +
        parseInt(campaignID),
      method: "GET",
    }).then((response) => {
      if (response.status) {
        loader.apiComplete();
        setFormData(objectFromResponse(response.data));
      }
    });

    let arr = [];
    axios({
      url: "/user/getAllRelevantDataProviders",
      method: "POST",
      data: {
        sender_userId: parseInt(userID),
        sender_brandId: parseInt(activeBrand.ID),
        sender_campaignId: parseInt(campaignID),
      },
    }).then((response) => {
      if (response.status) {
        axios({
          url: "/user/getDistictUserCount",
          method: "POST",
          data: {
            sender_userId: parseInt(userID),
            sender_brandId: parseInt(activeBrand.ID),
            sender_campaignId: parseInt(campaignID),
          },
        }).then((user) => {
          if (user.status) {
            loader.apiComplete();

            setUsers({
              common: response.data.common_user_count,
              total: response.data.totalUsers,
              neededMandate: response.data.needed_mandate,
              nonNeededMandate: response.data.needed_nonMandate,
            });
          }
        });

        for (let con of response.data?.DP) {
          if (con !== null && con.brands.length > 0) {
            arr.push({
              business_entity_id: con.business_entity_id,
              email: con.email,
              isRequested: con.isRequested,
              p_id: con.p_id,
              user_id: con.user_id,
              proof: con.proof,
              note: con.note || "",
              requestStatus: con.requestStatus,
              mandateMatched: con.matched_mandate,
              brand: {
                logo: con.brands[0]?.logo,
                mau: toInternationalFormat(con.brands[0]?.mau) || "",
                brandId: con.brands[0]?.brandId,
                category: con.brands[0]?.category,
                languages: con.brands[0]?.languages,
                locations: con.brands[0]?.locations,
                name: con.brands[0]?.name,
              },
            });
          }
        }
        setConnectNowLoading(arr.map(() => false));
        setConnections(arr);
        loader.apiComplete();
      } else {
        loader.stop(2);
      }
    });
  }, [
    axios,
    loader,
    campaignID,
    activeBrand.ID,
    userID,
    sentChanges.requestSent,
    sentChanges.verifiedProof,
  ]);

  let isApproved = connections.filter((items) => {
    return items.proof.isApproved === true;
  });

  return (
    <Fragment>
      <Loader>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <PageHeader
              heading={formData.campaign_name.value}
              pageName={"Recommended Connections"}
            />
          </Grid>

          <Grid item xs={12} />

          <Grid item alignSelf={"center"}>
            <Chip
              className="match-needed"
              label={"Mandate Need: " + users.neededMandate}
            />
          </Grid>

          <Grid item alignSelf={"center"}>
            <Chip
              className="match-needed"
              label={"Non-Mandate Need: " + users.nonNeededMandate}
            />
          </Grid>

          <Grid item alignSelf={"center"}>
            <Chip
              className="match-needed"
              label={"Common Match: " + users.common}
            />
          </Grid>

          <Grid item xs />

          {formData.campaignStatus === "INITIATED" && (
            <Grid item alignSelf={"center"}>
              <Chip
                className="campaign-status"
                label={"CAMPAIGN " + formData.campaignStatus}
              />
            </Grid>
          )}

          <Grid item textAlign="end" spacing={3}>
            <CancelButton
              variant="outlined"
              onClick={() => navigate(pages.campaignDetails.route + campaignID)}
            >
              {" "}
              Back
            </CancelButton>

            {Boolean(formData?.adminCampaignStatus) &&
              formData?.campaignLaunched &&
              !formData.campaignInitiated &&
              launchCampaign &&
              Boolean(isApproved) && (
                <Accept
                  variant="contained"
                  onClick={() => setConfirm({ state: true })}
                  sx={{ marginLeft: "12px" }}
                >
                  {" "}
                  Launch Campaign
                </Accept>
              )}
          </Grid>

          <Grid item xs={12} />
        </Grid>

        {connections.length !== 0 ? (
          <List
            users={users}
            formData={formData}
            campaignID={campaignID}
            connections={connections}
            connectNowLoading={connectNowLoading}
            setConnectNowLoading={setConnectNowLoading}
            setSentChanges={setSentChanges}
          />
        ) : (
          <Grid item xs={12} textAlign="center" mt={15}>
            <Typography style={{ fontWeight: "500", fontSize: "30px" }}>
              There are no providers matched to your target audience.
            </Typography>
          </Grid>
        )}
      </Loader>

      <LaunchCampaignConfirm
        setFormData={setFormData}
        confirm={confirm}
        setConfirm={setConfirm}
        campaignID={campaignID}
        setLaunchCampaign={setLaunchCampaign}
      />
    </Fragment>
  );
}
